import { render, staticRenderFns } from "./Sip.vue?vue&type=template&id=1b0b0c44&"
import script from "./Sip.vue?vue&type=script&lang=js&"
export * from "./Sip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports